import type { SiteControllerSettingBaseFormModel } from "../../../type";
import type { ServerModel } from "../../use-initialized/type";

type Props = {
	serverModel: ServerModel;
};

/**
 * 複数のサイトコントローラーで共通で使用しているプロパティがあるため、固有のプロパティが存在しない場合がある
 */
export const serverModelToInputModelConverter = ({ serverModel: { siteControllerSetting } }: Props) => {
	return {
		siteControllerType: siteControllerSetting.siteControllerType,
		setUpRoomPriceByChillnn: siteControllerSetting.setUpRoomPriceByChillnn,
		hotelID: siteControllerSetting.hotelID,

		// not using

		// beds24
		beds24AuthenticationApiKey: siteControllerSetting.beds24AuthenticationApiKey ?? "",
		beds24AuthenticationPropKey: siteControllerSetting.beds24AuthenticationPropKey ?? "",
		beds24RoomTypeMapping: siteControllerSetting.beds24RoomTypeMapping ?? [],

		// ねっぱん or 手間いらず
		password: siteControllerSetting.password ?? "",

		// TL-Lincoln
		tll: {
			defaultPlan: siteControllerSetting.tll?.defaultPlan,
			rooms: siteControllerSetting.tll?.rooms ?? [],
			plans: siteControllerSetting.tll?.plans ?? [],
			tllID: siteControllerSetting.tll?.tllID ?? "",
		},

		airHostSettings: {
			airHostAPIAccessToken: siteControllerSetting.airHostSettings?.airHostAPIAccessToken ?? "",
			airHostPartnerID: siteControllerSetting.airHostSettings?.airHostPartnerID ?? "",
			airHostPropertyID: siteControllerSetting.airHostSettings?.airHostPropertyID ?? "",
			chillnnRoomAndAirHostPricePlanMappings:
				siteControllerSetting.airHostSettings?.chillnnRoomAndAirHostPricePlanMappings ?? [],
		},
	} satisfies SiteControllerSettingBaseFormModel["InputModel"];
};
